let genericIds = {
  header_mis_reports_payment : "MIS Reports -  Payment",
}

export default {
  ...genericIds
}